var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jm-upload',_vm._g(_vm._b({attrs:{"action":"/newfib.php/index/api_base/uploadFile","on-preview":_vm.download,"on-success":_vm.uploadSuccess}},'jm-upload',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }